import React from 'react';
import './footer.scss';

import fscsImg from '../../assets/images/fscs-logo.svg';
import {footerLinks} from './footerLinks';

const Footer = (/** @type {{ noBorder?: boolean}} */ { noBorder = false }) => {
    return (
        <footer>
            <div className='footer__wrapper'>
                <div className='footer__image footer__fscs-logo'>
                    <a target="_blank" href="https://www.fscs.org.uk" rel="noreferrer">
                        <img src={fscsImg} className='footer__fscs-logo-img' alt="FSCS Protected" />
                    </a>
                </div>
                <ul className='footerP3__links'>
                    { renderFooterLinks(footerLinks) }
                </ul>
            </div>
        </footer>
    );
};

const renderFooterLinks = (/** @type {import('./FooterTypes').FooterLink[]} */ links) => {
    return links.map(({ link, text, iconSrc, iconClass }, i) => (
        <li className='footer__link' key={i}>
            <a target="_blank" href={link} rel="noreferrer">{text}</a>
        </li>
    ));
};

export default Footer;
